import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.article.itemsLoading;
export const getItemsSelect = (state:RootState) => state.article.dropDownItems;